import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import FundCodeForm from "components/FundCode/form"
import { storeFundCode } from "store/fund-code/fund-code-action"

const AddFundCode = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading, error } = useSelector(state => state.fundCode)

  return (
    <FundCodeForm
      onSubmit={values => dispatch(storeFundCode(values, navigate))}
      loading={loading}
      error={error}
      formMode={"Add"}
    />
  )
}

export default AddFundCode
